import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'split-select-button',
  templateUrl: './split-select-button.component.html',
  styleUrls: ['./split-select-button.component.scss']
})
export class SplitSelectButtonComponent {

  @Input() style!: any;
  @Input() public options: Array<any> = [
    { label: 'Off', value: 'off' },
    { label: 'On', value: 'on' }
  ];

  @Output() public onOptionClick: EventEmitter<any> = new EventEmitter<any>();
  

  active: number = 0;

  select(position: number) {
    this.active = position;
    this.onOptionClick.emit(this.options[position]);
  }
}
